import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'


const available = (record) => hasAvailableAction(record, 'cancel')

// eslint-disable-next-line react/display-name
const cancelForm = () => (
  <fieldset>
    Are you sure you want to cancel all submissions against this enrolment?
    <br />
    You will need to manually resubmit for this child.
  </fieldset>
)

const apiEndPoint = ({ gov_id }) => (
  process.env.REACT_APP_API_HOST + `/api/gov-enrolments/${gov_id}/cancel-session-reports`
)

const cancelSubmissions = ({ record }) => (
  available(record) ?
    {
      label: 'Cancel All Submissions',
      value: 'cancel_submission',
      component: cancelForm,
      url: apiEndPoint(record),
    } :
    null
)

export default cancelSubmissions



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/cancel-submissions.js